<!--
    © Copyright Existek LTD. All rights reserved.
    * Existek Nest Angular StartKit.
    * Proprietary and confidential.
    * Unauthorized copying of this file, via any medium is strictly prohibited.
-->
<router-outlet>
  <tour-step-template></tour-step-template>
</router-outlet>
